import { render, staticRenderFns } from "./UserPublishInformation.vue?vue&type=template&id=72e9b75a&scoped=true"
import script from "./UserPublishInformation.vue?vue&type=script&lang=js"
export * from "./UserPublishInformation.vue?vue&type=script&lang=js"
import style0 from "./UserPublishInformation.vue?vue&type=style&index=0&id=72e9b75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9b75a",
  null
  
)

export default component.exports